import request from "@/utils/request"
import service from "@/utils/service"

// 登录
export function regToken(params) {
  return request({
    url: service.tcode + "/oauth/regtoken",
    method: "post",
    data: params
  });
}



// 刷新
export function refreshToken() {
  return request({
    url: service.tcode + "/oauth/refreshToken",
    method: "get"
  });
}

// 忘记密码
export function forgotPwdFirst(params) {
  return request({
    url: service.tcode + "/oauth/forgotPwdFirst",
    method: "post",
    data: params
  });
}

/**
 * SSO
 */
export function regSso(params) {
  return request({
    url: service.tcode + "/oauth/regSso",
    method: "post",
    data: params
  })
}

// 登录
export function regTokenPc(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/regtoken",
    method: "post",
    data: params
  });
}

/**
 * google登录
 * @param data 保存数据
 */
export function loginWithGoogle(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/bindUser",
    method: "post",
    data: params
  })
}

// 更换密码
export function changePassword(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/changePassword",
    method: "post",
    data: params
  });
}
//换绑邮箱第一步:发送验证码
export function changeEmailVerifyCodeEmail(sendMap){
  return request({
    url: service.tcode + "/tcode/api/pub/changeEmailVerifyCodeEmail",
    method: "post",
    data: sendMap
  });
}
//换绑邮箱第二步:更换邮箱
export function changeEmail(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/changeEmail",
    method: "post",
    data: params
  });
}
// 修改昵称
export function changeDisplayName(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/changeDisplayName",
    method: "post",
    data: params
  });
}

// 更换头像
export function changeAvatar(avatarMap) {
  return request({
    url: service.tcode + "/tcode/api/pub/changeAvatar",
    method: "post",
    data: avatarMap
  });
}

/**
 * 用户邮箱注册
 */
export function register(params) {
  return request({
    url: service.tcode + "/tcode/api/pub/registerWeb",
    method: "post",
    data: params
  });
}

export function getServerTime() {
  return request({
    url: service.tcode + "/tcode/api/auth/getServerTime",
    method: "get",
  });
}

/**
 * 判断是否会员
 * @param pk_user 用户pk_user
 */
export function judgeIsMember(pk_user) {
  return request({
    url: service.tcode + "/tcode/api/auth/judgeIsMember/" + pk_user,
    method: "get"
  })
}

/**
 * 保存用户邮不成为会员的原因
 */
export function updateUserReason(params) {
  return request({
    url: service.tcode + "/tcode/user/updateUserReason",
    method: "post",
    data: params
  });
}

/**
 * 保存用户终端平台信息
 */
export function saveUserPlatform(params) {
  return request({
    url: service.tcode + "/tcode/userPlatform/saveUserPlatform",
    method: "post",
    data: params
  });
}

/**
 * 判断是否会员
 * @param code 设备code
 */
export function findDeviceByCode(code) {
  return request({
    url: service.tcode + "/tcode/api/auth/findDeviceByCode/" + code,
    method: "get"
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/auth.js